import { SimpleGrid } from '@chakra-ui/react'

import { Citizen } from 'CitizenProfile/types'
import { capitalizeString } from 'utils/transforms/string'
import { Span } from 'components'
import { formatDateToString } from 'utils/transforms/date'
import { SEXES_OBJECT } from 'constants/variables'

type Props = {
  person: Citizen
}

export default function CustomFormPersonByCPF({ person }: Props) {
  if (!person.name) return null
  return (
    <SimpleGrid columns={[1, 1, 2, 2, 2, 2]} gap={1} mt={2}>
      <Span label="Nome: " value={capitalizeString(person.name)} />
      <Span label="Nome da mãe: " value={capitalizeString(person.mother_name)} />
      <Span label="Nome do pai: " value={capitalizeString(person.father_name)} />
      <Span label="Data de nascimento: " value={formatDateToString(person.birth_certificate_date, false)} />
      <Span label="Sexo: " value={SEXES_OBJECT[person.sex || 'UNKNOWM']} />
    </SimpleGrid>
  )
}
